import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      SUBSCRIPTION_STATUS: "Status for abonnement",
      STATUS: "inaktiv",
      YOUR_SUBSCRIPTION_IS_CANCELLED: "Ditt abonnement er avsluttet",
      WE_NO_LONGER_DELIVER_TO_YOU:
        "Ditt abonnement er avsluttet fordi vi ikke leverer til din adresse lenger.",
      IF_WE_DO_IN_THE_FUTURE:
        "Hvis det endrer seg i fremtiden tar vi kontakt med deg.",
      CONTACT_CUSTOMER_SERVICE: "Kontakt kundeservice",
    },
    dk: {
      SUBSCRIPTION_STATUS: "Status på abonnement",
      STATUS: "annulleret",
      YOUR_SUBSCRIPTION_IS_CANCELLED: "Dit abonnement er opsagt",
      WE_NO_LONGER_DELIVER_TO_YOU:
        "Dit abonnement er opsagt, da vi ikke længere leverer til din adresse.",
      IF_WE_DO_IN_THE_FUTURE:
        "Hvis dette ændrer sig i fremtiden, giver vi dig besked.",
      CONTACT_CUSTOMER_SERVICE: "Kontakt kundeservice",
    },
    se: {
      SUBSCRIPTION_STATUS: "Prenumerationsstatus",
      STATUS: "avslutad",
      YOUR_SUBSCRIPTION_IS_CANCELLED: "Din prenumeration är avslutad",
      WE_NO_LONGER_DELIVER_TO_YOU:
        "Din prenumeration är avslutad eftersom vi inte kan leverera till din adress just nu.",
      IF_WE_DO_IN_THE_FUTURE:
        "Vi hör av oss när och om vi kan leverera till din adress i framtiden. Då kan du välja att aktivera din prenumeration igen.",
      CONTACT_CUSTOMER_SERVICE: "Kontakta kundtjänst",
    },
  } as const
)[language];
